module.exports = __webpack_public_path__ + "static/media/Drilling Services.243e4ecb.png";